import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Role } from '@data/models/role.model';
import { UserRole } from '@data/models/authorization.model';
import { ScopeHelper } from '@modules/users/scope.helper';

@Component({

    selector: 'syn-bot-acls-warning',
    templateUrl: 'bot-acls-warning.component.html'
})
export class BotAclsWarningComponent extends ScopeHelper implements OnInit {

    @Input()
    private userRoles?: UserRole[];
    @Input()
    private globalRoles?: Role[];
    @Input()
    private scopes?: Array<{ key: string; read: boolean; edit: boolean; admin: boolean }>;

    public missingRoles: Array<string> = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data?: {
            userRoles: UserRole[];
            globalRoles: Role[];
            scopes: Array<{ key: string; read: boolean; edit: boolean; admin: boolean }>;
            title: string;
        }
    ) {
        super();
    }

    ngOnInit() {
        this.data = {
            ...this.data,
            userRoles: this.userRoles || this.data.userRoles,
            globalRoles: this.globalRoles || this.data.globalRoles,
            scopes: this.scopes || this.data.scopes,
        };
        this.missingRoles.push(...this.getMissingRoles(this.data.userRoles, this.data.globalRoles, this.data.scopes));
    }

}
